// 系统工具路由
export default {
    path: 'sysTool',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '系统工具'},
    children: [
        //文档检测
        {
            path: 'docCheck',
            component: () => import('@/components/RouterView'),
            redirect: '/sysTool/docCheck/list',
            meta: { title: '文档检测'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/sysTool/docCheck/list'),
                    meta: {title: '文档检测'}
                }
            ]
        },
        {
            path: 'shortUrl',
            component: () => import('@/views/sysTool/shortUrl/index.vue'),
            meta: {title: '小程序链接'}
        }
    ]
};
